import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mm-total-results',
  templateUrl: './total-results.component.html',
  styleUrls: ['./total-results.component.scss']
})
export class TotalResultsComponent implements OnInit {
  @Input() displayedRows: number;
  
  constructor() { }

  ngOnInit(): void {
  }

}